/**
 * @file: useWithMediaLibraryPermissions.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { onErrorIgnore } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import * as MediaLibrary from 'expo-media-library';
import { PermissionStatus } from 'expo-media-library';
import { useEffect } from 'react';

export const useWithMediaLibraryPermissions = (callback: () => any) => {
  const onPermissionGranted = usePersistFn(() => {
    callback();
  });

  useEffect(() => {
    (async () => {
      const { status, canAskAgain } = await MediaLibrary.getPermissionsAsync();
      if (status === PermissionStatus.GRANTED) {
        onPermissionGranted();
        return;
      }
      if (
        status === PermissionStatus.UNDETERMINED ||
        (status === PermissionStatus.DENIED && canAskAgain)
      ) {
        const result = await MediaLibrary.requestPermissionsAsync();
        if (result.status === PermissionStatus.GRANTED) {
          onPermissionGranted();
        }
      }
    })().catch(onErrorIgnore);
  }, [onPermissionGranted]);
};
